export default __webpack_public_path__ + "static/media/quick-starter-badge.08ac7dc0.png";